// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2EVJV","loaderOuter":"PageOverlayLoader_loaderOuter__1MdOH"};